import sendForm from "@scripts/modules/sendForm/sendForm";
import { setFormTitleAndSubject } from './setFormTitleAndSubject';

const forms = document.querySelectorAll(".form");

// Инициализация функции обработки заголовков и заголовков форм
setFormTitleAndSubject();
const formSubject = document.querySelector("input[name='subject']").getAttribute("value") || null;
let isSubmitting = false;

// setFormTitleAndSubject({ btn: item })

// ОБРАБАТЫВАЕМ КАПТЧУ, ЕСЛИ ОНА ЕСТЬ
function onSubmitForm(hasRecaptcha, form) {
    if (isSubmitting) return; // Блокируем отправку, если запрос уже в процессе
    isSubmitting = true; // Устанавливаем флаг, что запрос обрабатывается

    if (hasRecaptcha) {
        grecaptcha.ready(function () {
            // Секретный ключ reCAPTCHA
            grecaptcha.execute("6LdgDmcqAAAAAN807WQzyW7hOlZbE8eBdaOKU5Di", { action: "submit" }).then(function (token) {
                onSubmit(form, token).finally(() => {
                    isSubmitting = false; // Сбрасываем флаг после завершения
                });
            });
        });
    } else {
        onSubmit(form).finally(() => {
            isSubmitting = false; // Сбрасываем флаг после завершения
        });
    }
}

// ПЕРЕДАЕМ TOKEN RECAPTCHA В sendFrom(). onSubmit(token) - функция google
async function onSubmit(form, token) {
    await sendForm(form, token);
}

// СОБЫТИЕ ОТПРАВКИ ФОРМЫ
forms.forEach(form => {
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        onSubmitForm(false, form);
    });
});

export { formSubject };
